export default __webpack_public_path__ + "images/Savings.v-9d07fa4096207ef2b3677b2cb34d1309.png";